

/**
 * @description The function to login to Ink Finder
 * @param {object} Auth The service providing authentication
 * @param {unknown} $state The $state service from ui-router
 * @param {unknown} $rootScope Unknown
 * @param {object} DEFAULT_STATES The constant to defines default states based on role type
 * @param {object} SWITCH_MESSAGE Constant for state switch messages
 * @param {array} AUTH_EVENTS A constant containing an array of auth events to use global
 * @param {object} AlertMessages A service for alerts.
 * @param {object} Events System events service
 * @param {object} Session Session service
 * @param {unknown} $cookies Angular cookies service
 * @param {library} _ The Lodash library
 */
function LoginController(
  Auth,
  $state,
  $rootScope,
  DEFAULT_STATES,
  SWITCH_MESSAGE,
  AUTH_EVENTS,
  AlertMessages,
  Events,
  Session,
  $cookies,
  _
) {
  let vm = this;

  // Defaults
  vm.$onInit = function() {
    vm.type = _.isUndefined(vm.type) ? 'fixed' : vm.type;
    vm.loginModalOpen = false;
    vm.session = Session;
    vm.login = login;
    vm.authenticate = authenticate;
    vm.logout = logout;
    vm.switchToBuying = switchToBuying;
    vm.credentials = {};
    vm.changeState = changeState;
  };

  /**
   * @name login
   * @description Login via an Ink Finder account
   * @param {object} credentials The object passing email/password
   */
  function login(credentials) {
    Auth.loginInkfinder(credentials).then(function(response) {
      vm.credentials = null;
      Events.loggedIn = true;
      Auth.routeAfterAuthentication();
    })
    .catch(function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name authenticate
   * @description Login via Social API through Satellizer
   * @param {unknown} provider Unknown
   */
  function authenticate(provider) {
    Auth.loginSocial(provider).then(function(response) {
      vm.credentials = null;
      Events.loggedIn = true;
      Auth.routeAfterAuthentication();
    })
    .catch(function(error) {
      AlertMessages.add({
        msg: error, // This will catch the error message from Satellizer
        type: 'danger'
      });
    });
  }

  /**
   * @name changeState
   * @description Function to change states (buy/selling) and the user role
   * associated with the state
   * @param {object} activeState The selected state
   */
  function changeState(activeState) {
    $rootScope.$broadcast('clear-data');
    Session.setActiveState(activeState);
    $cookies.putObject('inkfinder', activeState);
    if (activeState.role === 'operator') {
      $state.go(DEFAULT_STATES.operator);
    } else {
      $state.go(DEFAULT_STATES.artist);
    }
  }

  /**
   * @name switchToBuying
   * @description Function to move the user to the collector's dashboard
   */
  function switchToBuying() {
    const state = {
      mode: 'buying',
      role: 'collector',
      switchMessage: SWITCH_MESSAGE.buying,
      id: 1
    };
    $rootScope.$broadcast('clear-data');
    Session.setActiveState(state);
    $cookies.putObject('inkfinder', state);
    $state.go(DEFAULT_STATES.buying);
  }

  /**
   * @name logout
   * @description Wrapper for the Auth logout function
   */
  function logout() {
    Auth.logout();
  }
}

angular
  .module('inkfinder')
  .controller('LoginController', LoginController);



// WEBPACK FOOTER //
// ./components/login/login.controller.js